var map = {
	"./fc1.jpg": 3084,
	"./fc2.jpg": 1879,
	"./fc3.jpg": 2657,
	"./fc4.jpg": 70,
	"./fc5.jpg": 3141,
	"assets/collections/editorials/fish and chips/fc1.jpg": 3084,
	"assets/collections/editorials/fish and chips/fc2.jpg": 1879,
	"assets/collections/editorials/fish and chips/fc3.jpg": 2657,
	"assets/collections/editorials/fish and chips/fc4.jpg": 70,
	"assets/collections/editorials/fish and chips/fc5.jpg": 3141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7079;